import { render } from "./SendSMS.vue?vue&type=template&id=556ee310&scoped=true"
import script from "./SendSMS.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SendSMS.vue?vue&type=script&charset=utf-8&lang=js"

import "./SendSMS.vue?vue&type=style&index=0&id=556ee310&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556ee310"]])

export default __exports__